import { Navigate, useRoutes } from 'react-router-dom';
// auth
import GuestGuard from '../auth/GuestGuard';
import AuthGuard from '../auth/AuthGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
import MarketingAssetsLayout from '../layouts/marketingassets';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  AvalonModelComparison,
  AvalonProductTraining,
  AvalonWaketoonTraining,
  BoatOrderPage,
  BoatPriceListPage,
  CoOpClaimForm,
  CoOpPage,
  DamagedEngineProcess,
  DealerinvoicesPage,
  ImportantInfoPage,
  LoginPage,
  ModelGalleryPage,
  MotorPriceListPage,
  MSORequest,
  NewOwnerAdvisoryChecklist,
  OptionPriceListPage,
  Page404,
  QuickOrderForm,
  ReturnGoodsForm,
  SpecSheetsPage,
  TahoeModelComparison,
  TahoeProductTraining,
  TahoeWaketoonTraining,
  ViewInvoicePage,
  ViewOrderPage,
  WarrantyRegistrationPage,
  WarrantyRegistrationForm,
  WarrantyClaimForm,
  RegionalMapPage,
  ServicePartsPricingPage,
  WarrantyTransferPage,
  WrittenWarrantyPage,
  WarrantyProcedurePage,
  PaperWarrantyClaimPage,
  ServiceOrderPage,
  TechnicalInformationViewPage,
  ManualsViewPage,
  PartLookupPage,
  AvalonBrochuresPage,
  TahoeBrochuresPage,
  PartLookupBoatEntry,
  BoatInventoryPage,
  PartOrderPage,
  RMAHome,
  PartOrderList,
  OpenHousePresentationPage,
  TrainingDayPage,
  CreateNewManualCategory,
  ManualCategory,
  ManualSecondaryCategory,
  CreateManualPage,
  MarketingToolsPage,
  AvalonVideosPage,
  TahoeVideosPage,
  OnlineOrders,
  TechnicalInformationPrimaryCategory,
  TechnicalInformationSecondaryCategory,
  TechnicalInformation,
  TechnicalInformationViewTemp,
  ScoreCardPage,
  DealerPortalMaintenanceAdmin,
  ViewWarrantyRegistration,
  StockBoat,
  InvoiceTool,
  DealerInvoiceTool,
  Attoonshop,
  Contactlist,
  Floorplanoverview,
  FusionPackages,
  HistoryMissionStatement,
  InternetAdvertising,
  MarketingStrategy,
  Instoremarketing,
  OwnerAdvisoryChecklist,
  OnlineDealerResources,
  PaintCodes,
  InspectionPictures,
  InspectionPictureLookup,
  ShipperPictures,
  ViewShipperPictures,
  ViewPictureGroups,
  RMAView,
  OpenHouseBoatsPage,
  DealerWarrantyRegistrationForm,
  DealerWarrantyClaimForm,
  NoAuthViewInvoice,
  NoAuthViewOrder,
  ViewStockOrder,
  MaintenancePortal,
  ViewStatement,
  MaintenanceDashboard,
  MaintenancePortalChatBot,
  TakeInspectionPictures,
  BarcodeScanner,
  ChangeOrderEntry,
  ChangeOrderTable,
  ChangeOrderByBoatTable,
  FindChangeOrder,
  NoAuthViewJobTraveller,
  ServiceOrderStatus,
  BulletinsAdmin,
  EditBulletin,
  MotorInventory,
  SocialMedia,
  UploadSocialMedia,
  DealerMeetingImages,
  DealerWarrantyClaimTracker,
  CSWarrantyTracker,
  CSWarrantyTrackerViewClaim,
  DealerViewWarrantyClaim,
  ViewCheckSheet,
  ModelGalleryUploadPage,
  MetalJacket,
} from './elements';
import DealerWarrantyRegistrationPage from '../pages/DealerWarrantyTable';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      children: [
        {
          path: 'quality',
          children: [
            { path: 'inspectionpictures/:boat', element: <TakeInspectionPictures /> },
            { path: 'barcodescanner', element: <BarcodeScanner /> },
          ],
        },
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login/:dealerid',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'login/:dealerid/:seconddealerid',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: '/dealerportal',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dealermeeting',
          children: [
            { path: 'openhousepresentation', element: <OpenHousePresentationPage /> },
            { path: 'openhouseboats', element: <OpenHouseBoatsPage /> },
          ],
        },
        {
          path: 'dealerbook',
          children: [
            { path: 'boatpricelist', element: <BoatPriceListPage /> },
            { path: 'motorpricelist', element: <MotorPriceListPage /> },
            { path: 'optionpricelist', element: <OptionPriceListPage /> },
            { path: 'specsheets', element: <SpecSheetsPage /> },
            { path: 'coop', element: <CoOpPage /> },
            { path: 'importantinfo', element: <ImportantInfoPage /> },
            { path: 'attoonshop', element: <Attoonshop /> },
            { path: 'contactlist', element: <Contactlist /> },
            { path: 'floorplanoverview', element: <Floorplanoverview /> },
            { path: 'fusionpackages', element: <FusionPackages /> },
            { path: 'historymission', element: <HistoryMissionStatement /> },
            { path: 'internetadvertising', element: <InternetAdvertising /> },
            { path: 'marketingstrategy', element: <MarketingStrategy /> },
            { path: 'instoremarketing', element: <Instoremarketing /> },
            { path: 'owneradvisorylist', element: <OwnerAdvisoryChecklist /> },
            { path: 'onlinedealerresources', element: <OnlineDealerResources /> },
            { path: 'paintcodes', element: <PaintCodes /> },
            { path: 'metaljacket', element: <MetalJacket /> },
          ],
        },
        {
          path: 'account',
          children: [
            { path: 'dealerinvoices', element: <DealerinvoicesPage /> },
            { path: 'viewinvoice/:invoice', element: <ViewInvoicePage /> },
            { path: 'vieworder/:order', element: <ViewOrderPage /> },
            { path: 'viewstockorder/:order', element: <ViewStockOrder /> },
            { path: 'boatorders', element: <BoatOrderPage /> },
            { path: 'viewstatement', element: <ViewStatement /> },
          ],
        },
        {
          path: 'marketing',
          children: [
            { path: 'modelgallery/:year/:model', element: <ModelGalleryPage /> },
            { path: 'modelgalleryupload', element: <ModelGalleryUploadPage /> },
            { path: 'avalonbrochures', element: <AvalonBrochuresPage /> },
            { path: 'tahoebrochures', element: <TahoeBrochuresPage /> },
            { path: 'marketingtools', element: <MarketingToolsPage /> },
            { path: 'avalonvideos', element: <AvalonVideosPage /> },
            { path: 'tahoevideos', element: <TahoeVideosPage /> },
            { path: 'socialmedia', element: <SocialMedia /> },
            { path: 'upload-social-media', element: <UploadSocialMedia /> },
          ],
        },
        {
          path: 'warranty',
          children: [
            { path: 'warrantyregistration', element: <WarrantyRegistrationPage /> },
            { path: 'warrantyregistrationform/:boatnumber', element: <WarrantyRegistrationForm /> },
            { path: 'warrantyclaimform/:boatnumber/:stock', element: <WarrantyClaimForm /> },
            { path: 'warrantytransfer', element: <WarrantyTransferPage /> },
            { path: 'writtenwarranty', element: <WrittenWarrantyPage /> },
            { path: 'warrantyprocedure', element: <WarrantyProcedurePage /> },
            { path: 'paperwarrantyclaimform', element: <PaperWarrantyClaimPage /> },
            { path: 'viewregistration/:boatnumber', element: <ViewWarrantyRegistration /> },
            { path: 'warrantyclaimtracker', element: <DealerWarrantyClaimTracker /> },
            { path: 'viewwarrantyclaim/:id', element: <DealerViewWarrantyClaim /> },
          ],
        },
        {
          path: 'training',
          children: [
            { path: 'trainingday', element: <TrainingDayPage /> },
            { path: 'damagedengineprocess', element: <DamagedEngineProcess /> },
            { path: 'avalonproducttraining', element: <AvalonProductTraining /> },
            { path: 'tahoeproducttraining', element: <TahoeProductTraining /> },
            { path: 'avalonmodelcomparison', element: <AvalonModelComparison /> },
            { path: 'tahoemodelcomparison', element: <TahoeModelComparison /> },
            { path: 'avalonwaketoontraining', element: <AvalonWaketoonTraining /> },
            { path: 'tahoewaketoontraining', element: <TahoeWaketoonTraining /> },
          ],
        },
        {
          path: 'paperforms',
          children: [
            { path: 'coopclaimform', element: <CoOpClaimForm /> },
            { path: 'newadvisorchecklist', element: <NewOwnerAdvisoryChecklist /> },
            { path: 'quickorderform', element: <QuickOrderForm /> },
            { path: 'returngoodsform', element: <ReturnGoodsForm /> },
            { path: 'msorequest', element: <MSORequest /> },
          ],
        },
        {
          path: 'inventory',
          children: [
            { path: 'boatinventory', element: <BoatInventoryPage /> },
            { path: 'stockboat', element: <StockBoat /> },
          ],
        },
        {
          path: 'customerservice',
          children: [
            { path: 'regionalmap', element: <RegionalMapPage /> },
            { path: 'serviceorderstatus', element: <ServiceOrderStatus /> },
            { path: 'servicepartspricing', element: <ServicePartsPricingPage /> },
            { path: 'partlookup/:boatnum', element: <PartLookupPage /> },
            { path: 'partlookupboatentry', element: <PartLookupBoatEntry /> },
            { path: 'inspectionpicture/:boatnum', element: <InspectionPictures /> },
            { path: 'inspectionpicturelookup', element: <InspectionPictureLookup /> },
            { path: 'serviceorder', element: <ServiceOrderPage /> },
            { path: 'partorder', element: <PartOrderPage /> },
            { path: 'partorderlist', element: <PartOrderList /> },
            { path: 'rmahome', element: <RMAHome /> },
            { path: 'viewrma/:rma', element: <RMAView /> },
          ],
        },

        {
          path: 'technicalinformation',
          children: [{ path: 'view/:id', element: <TechnicalInformationViewPage /> }],
        },
        {
          path: 'manuals',
          children: [{ path: 'view/:id', element: <ManualsViewPage /> }],
        },
      ],
    },
    {
      // Public mirror of /dealerportal/marketing — no AuthGuard on purpose.
      // The side nav is derived from the dashboard nav config, see
      // ../layouts/marketingassets/config-navigation.js
      path: '/marketingassets',
      element: <MarketingAssetsLayout />,
      children: [
        { element: <Navigate to="/marketingassets/marketingtools" replace />, index: true },
        { path: 'modelgallery/:year/:model', element: <ModelGalleryPage /> },
        { path: 'avalonbrochures', element: <AvalonBrochuresPage /> },
        { path: 'tahoebrochures', element: <TahoeBrochuresPage /> },
        { path: 'marketingtools', element: <MarketingToolsPage /> },
        { path: 'avalonvideos', element: <AvalonVideosPage /> },
        { path: 'tahoevideos', element: <TahoeVideosPage /> },
        { path: 'socialmedia', element: <SocialMedia /> },
        // modelgalleryupload and upload-social-media stay behind AuthGuard.
      ],
    },
    {
      path: 'survey/scorecard/:shipper',
      element: (
        <GuestGuard>
          <ScoreCardPage />
        </GuestGuard>
      ),
    },
    {
      path: 'tools',
      children: [
        { path: 'invoicesender', element: <InvoiceTool /> },
        { path: 'dealerinvoice/:id', element: <DealerInvoiceTool /> },

        { path: 'dealerregistration/:id', element: <DealerWarrantyRegistrationPage /> },
        {
          path: 'dealerregistrationform/:id/:boatnumber',
          element: <DealerWarrantyRegistrationForm />,
        },
        {
          path: 'dealerclaimform/:id/:boatnumber/:stock',
          element: <DealerWarrantyClaimForm />,
        },
        { path: 'viewinvoice/:invoice', element: <NoAuthViewInvoice /> },
        { path: 'vieworder/:order', element: <NoAuthViewOrder /> },

        { path: 'viewregistration/:boatnumber', element: <ViewWarrantyRegistration /> },
        { path: 'viewjobtraveller/:order', element: <NoAuthViewJobTraveller /> },
        { path: 'motorinventory', element: <MotorInventory /> },
      ],
    },
    {
      path: '/dealerportalmaintenance',
      element: <DashboardLayout />,
      children: [
        {
          path: 'admin',
          element: <DealerPortalMaintenanceAdmin />,
        },
        {
          path: 'createmanualcategory',
          element: <CreateNewManualCategory />,
        },
        {
          path: 'manualcategory',
          element: <ManualCategory />,
        },
        { path: 'manualsecondarycategory', element: <ManualSecondaryCategory /> },
        {
          path: 'createmanual',
          element: <CreateManualPage />,
        },
        {
          path: 'technicalinformation',
          element: <TechnicalInformation />,
        },
        {
          path: 'technicalinformationprimarycategory',
          element: <TechnicalInformationPrimaryCategory />,
        },
        {
          path: 'technicalinformationsecondarycategory',
          element: <TechnicalInformationSecondaryCategory />,
        },
        {
          path: 'bulletinsadmin',
          element: <BulletinsAdmin />,
        },
        {
          path: 'editbulletin/:id',
          element: <EditBulletin />,
        },
      ],
    },
    {
      path: '/maintenanceportal',
      children: [
        {
          path: 'dashboard',
          element: <MaintenanceDashboard />,
        },
        {
          path: 'technicalinformation',
          element: <MaintenancePortal />,
        },
        {
          path: 'technicalinformation',
          children: [{ path: 'view/:id', element: <TechnicalInformationViewPage /> }],
        },
        {
          path: 'manuals',
          children: [{ path: 'view/:id', element: <ManualsViewPage /> }],
        },
        {
          path: 'chatbot',
          element: <MaintenancePortalChatBot />,
        },
        {
          path: 'cswarrantyclaimtracker',
          element: <CSWarrantyTracker />,
        },
        {
          path: 'cswarrantyclaimview/:id',
          element: <CSWarrantyTrackerViewClaim />,
        },
        {
          path: 'viewchecksheet/:id',
          element: <ViewCheckSheet />,
        },
      ],
    },

    {
      path: '/loadbuilding',
      children: [
        { path: 'inspectionpictures', element: <ShipperPictures /> },
        { path: 'uploadpictures/:id', element: <ViewShipperPictures /> },
        { path: 'viewshippingpicturegroups', element: <ViewPictureGroups /> },
      ],
    },
    {
      path: '/production',
      children: [],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
